import { IRootState } from 'reducers';
import { createSelector } from 'reselect';
import { extractDatesFromNestedItems } from 'utils';

export const personalDiagnosticsYearsSelector = createSelector(
  (state: IRootState) => state.personalDiagnostics.content,
  (personalDiagnostics) =>
    extractDatesFromNestedItems(
      [personalDiagnostics],
      [
        {
          type: 'academicYearString',
          field: 'learningYear',
        },
      ],
    ),
);
